import { ref, onMounted } from 'vue';

export function useResponsiveCollapse() {
  const collapsed = ref(false);

  const checkScreen = () => {
    // lg breakpoint in Tailwind is 1024px
    collapsed.value = window.innerWidth < 1024;
  };

  onMounted(() => {
    checkScreen();
    window.addEventListener('resize', checkScreen);
  });

  return {
    collapsed
  };
}
